module.exports = __webpack_public_path__ + "static/media/coffee-03.f352567f.png";